module.exports = __webpack_public_path__ + "static/media/empty.94c6d74b.svg";